import * as React from 'react'

import { taskPromptNode } from './directionsSection'
import { passageChunkRequests } from './readAloudPassage'

import { promptToSpeechText, reactNodeToSpeechText, useReadAloud } from '../../../Shared/index'
import { CLIP_SOURCE_TYPE, clipSource, StaticStringKey, staticStringSource } from '../../../Shared/libs/speech/clipSource'
import { prepareSpeech, warmSpeech } from '../../../Shared/libs/speech/speechManager'
import staticStrings from '../../../Shared/libs/speech/staticStrings.json'

const DIRECTION_KEYS: StaticStringKey[] = ['evidence.highlightDirections', 'evidence.promptDirections', 'evidence.reflectionDirections']

export const evidenceClipTexts = (activity) => {
  const passage = activity.passages[0]
  const chunks = passageChunkRequests(activity.passages, activity.title, clipSource(CLIP_SOURCE_TYPE.EVIDENCE_ACTIVITY, activity.id))
  const directions = DIRECTION_KEYS.map(key => ({ source: staticStringSource(key), text: staticStrings[key], }))
  const passageSource = clipSource(CLIP_SOURCE_TYPE.EVIDENCE_PASSAGE, passage?.id)
  const task = { source: passageSource, text: reactNodeToSpeechText(taskPromptNode(passage?.highlight_prompt)), }
  const caption = { source: passageSource, text: promptToSpeechText(passage?.image_caption), }
  const essentialKnowledge = { source: passageSource, text: promptToSpeechText(passage?.essential_knowledge_text), }
  const stems = (activity.prompts || []).map(prompt => ({ source: clipSource(CLIP_SOURCE_TYPE.EVIDENCE_PROMPT, prompt.id), text: promptToSpeechText(prompt.text), }))
  const all = [...chunks, ...directions, task, caption, essentialKnowledge, ...stems].filter(request => request.text)
  return { all, warmFirst: [chunks[0]?.text, directions[0].text, task.text].filter(Boolean), }
}

const useEvidenceClipPrefetch = (activity) => {
  const { readAloudEnabled, } = useReadAloud()

  React.useEffect(() => {
    if (!readAloudEnabled || !activity) { return }

    const { all, warmFirst, } = evidenceClipTexts(activity)
    prepareSpeech(all).then(() => warmFirst.forEach(text => warmSpeech(text)))
  }, [readAloudEnabled, activity])
}

export default useEvidenceClipPrefetch
